import { alivePing } from "@shared/services/user.service";
import { FC, useEffect } from "react";
import { useMutation } from "react-query";
import utils from "@shared/utils/utils";

const UserAlivePing: FC = () => {
    const intervalTime =
      utils.getAppParameter("PingUserAliveThresholdInMinutes") * 1000 * 60;

  const { mutateAsync } = useMutation(alivePing);

  useEffect(() => {
    const interval = setInterval(() => {
      mutateAsync();
    }, intervalTime);

    return () => clearInterval(interval);
  }, [intervalTime, mutateAsync]);

  return null;
};

export default UserAlivePing;
